export default "__VITE_ASSET__J$gv7yiEKpnkgFNmpH4S5A__"